module.exports = __webpack_public_path__ + "img/ic_roadside.470cb800.svg";